<template>
    <div>
        <div class="tool">
            <h3 v-if="revealing">期刊分类</h3>
            <h3 v-if="!revealing">新闻热点</h3>
            <!-- <ul class="tool_ul">
                <el-tree :data="data" class="db-filter-tree research-filter" :props="defaultProps" @node-click="handleNodeClick" accordion></el-tree>
            </ul> -->
            <div class="content"  v-if="revealing">
                <div v-for="(item,index) in data" :key="index">
                    <!-- 一级菜单 -->
                    <div class="box" :class="check==item.id?'activate':''" @click="handleNodeClick(item)">
                        <!-- <span v-if="headChildren[index].head != ''" class="arrDown" ></span> -->
                        <i style="margin: 0px 5px;" :class="['fa', item.label=='显示全部'?'fa-th':'fa-align-center']"></i>
                        <div> {{item.label }}</div>
                    </div>
                    <!-- 二级前五个 -->
                    <div class="subbox" :class="check==a.id?'activate':''" @click="handleNodeClick(a)"  v-for="(a,i) in headChildren[index]" :key="i">
                        {{ a.label }}
                    </div>
                    <!-- 二级除前五个 -->
                    <div :class="['subbox' , num == index ? 'activate2':'activate1' ,check==b.id?'activate':'']" v-for="(b,j) in endChildren[index]" :key="j+5" @click="handleNodeClick(b)">
                        {{ b.label }}
                    </div>
                    <!-- 更多按钮 -->
                    <div v-if="index != 0" class="subbox" style="color: #0070c0;font-weight: bold; font-size: 15px;margin-left: 0px;" @click="toggle(index)">
                        <i class="fa fa-exchange" style="transform: rotate(90deg);"></i>
                        {{item.revealing}}</div>
                </div>
            </div>
            <div class="content" v-if="!revealing">
                <div v-for="(item,index) in data1" :key="index">
                    <div class="box" :class="check==item.label?'activate':''" @click="articleToggle(item)">
                        <i style="margin: 0px 5px;" :class="['fa', faicon[index]]"></i>
                        <div> {{item.label }}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <a href="https://ibiling.cn/paper?from=dtsypaper02" target="_blank"><img src="/static/images/adver/ibiling_banner.jpg" style="padding-top: 11px; width: 270px;"></a>
        
        <a href="https://www.citexs.com/AIHelp?s=dtsy" target="_blank"><img src="/static/images/adver/scidoc.png" style="padding-top: 11px;width: 270px;"></a>
        <img data-v-5d848f11="" src="/static/images/weiwen.png" style="padding-top: 11px; width: 180px;padding-left: 50px;"> -->

    </div>
  </template>

  <script>
  import request from "../utils/request";

  export default {
    name: "PaperCheckLeftBar",
      data() {
        return {
            revealing:'',
            data1: [
                {"label":"显示全部"},
                {"label":"热点资讯"},
                {"label":"生物研究"},
                {"label":"医疗健康"},
                // {"label":"文献解读"},
                {"label":"纳米医药"},
            ],
            faicon:['fa-th','fa-align-center','fa-paper-plane','fa-plus-square','fa-list-ul','fa-eject'],
            data: [
                {"label":"显示全部"},
                {
                "label":"生物学",
                "id":"1128",
                "children":[
                    {"label":"细胞生物学","id":"1063"},
                    {"label":"生物化学与分子生物学","id":"1007"},
                    {"label":"遗传学","id":"1017"},
                    {"label":"免疫学","id":"1035"},
                    {"label":"神经科学","id":"1008"},
                    {"label":"生物化学研究方法","id":"1085"},
                    {"label":"毒理学","id":"1052"},
                    {"label":"病理学","id":"1014"},
                    {"label":"发育生物学","id":"1076"},
                    {"label":"微生物学","id":"1032"},
                    {"label":"动物学","id":"1048"},
                    {"label":"真菌学","id":"1018"},
                    {"label":"细胞与组织工程","id":"1019"},
                    {"label":"昆虫学","id":"1026"},
                    {"label":"显微镜学","id":"1029"},
                    {"label":"生物技术与应用微生物学","id":"1033"},
                    {"label":"海洋与淡水生物学","id":"1053"},
                    {"label":"行为科学","id":"1010"},
                    {"label":"生理学","id":"1059"},
                    {"label":"心理学","id":"1061"},
                    {"label":"古生物学","id":"1062"},
                    {"label":"进化生物学","id":"1066"},
                    {"label":"生殖生物学","id":"1068"},
                    {"label":"寄生虫学","id":"1069"},
                    {"label":"病毒学","id":"1073"},
                    {"label":"数学与计算生物学","id":"1079"},
                    {"label":"解剖学与形态学","id":"1094"},
                    {"label":"鸟类学","id":"1095"}
                ],
                "revealing":"更多"
                },
                {
                    "label":"医学","id":"1002",
                    "children":[
                        {"label":"研究医学与试验医学","id":"1020"},
                        {"label":"肿瘤学","id":"1042"},
                        {"label":"全科与内科","id":"1071"},
                        {"label":"老年病学与老年医学","id":"1055"},
                        {"label":"胃肠病学与肝脏病学","id":"1045"},
                        {"label":"药理学与药剂学","id":"1140"},
                        {"label":"内分泌学与新陈代谢","id":"1047"},
                        {"label":"产科与妇科医学","id":"1012"},
                        {"label":"呼吸系统","id":"1036"},
                        {"label":"重症医学","id":"1050"},
                        {"label":"护理学","id":"1112"},
                        {"label":"泌尿学与肾脏学","id":"1054"},
                        {"label":"卫生保健科学与服务","id":"1005"},
                        {"label":"心脏与心血管系统","id":"1016"},
                        {"label":"医学实验室技术","id":"1074"},
                        {"label":"神经影像","id":"1028"},
                        {"label":"麻醉学","id":"1037"},
                        {"label":"男科学","id":"1038"},
                        {"label":"皮肤病学","id":"1039"},
                        {"label":"运动科学","id":"1044"},
                        {"label":"热带医学","id":"1046"},
                        {"label":"药物滥用","id":"10139"},
                        {"label":"法律医学","id":"1051"},
                        {"label":"牙科学与口腔外科医学","id":"1056"},
                        {"label":"初级卫生保健","id":"1057"},
                        {"label":"耳鼻喉科学","id":"1058"},
                        {"label":"临床神经学","id":"1015"},
                        {"label":"过敏症","id":"1064"},
                        {"label":"外科","id":"1065"},
                        {"label":"康复医学","id":"1067"},
                        {"label":"器官移植","id":"1070"},
                        {"label":"公共事业、环境与职业健康","id":"1075"},
                        {"label":"听力学与言语病理学","id":"1078"},
                        {"label":"儿科学","id":"1081"},
                        {"label":"传染病","id":"1083"},
                        {"label":"整形外科学","id":"1013"},
                        {"label":"医学信息学","id":"1087"},
                        {"label":"医学伦理学","id":"1138"},
                        {"label":"周围性血管疾病","id":"1089"},
                        {"label":"精神病学","id":"1091"},
                        {"label":"整合与替代医学","id":"1092"},
                        {"label":"放射学、核医学与医学成像","id":"1006"},
                        {"label":"眼科学","id":"1093"},
                        {"label":"风湿病学","id":"1097"},
                        {"label":"血液学","id":"1098"},
                        {"label":"急诊医学","id":"1001"}
                    ],
                    "revealing":"更多"
                }
            ],
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            // 用于存放二级菜单的前五个
            headChildren:[{head:''}],
            // 用于存放二级菜单除前五个之外的数据
            endChildren:[{end:''}],
            // 用于动态切换class判定当前二级菜单是否展开
            num:0,
            // 用于判定当点击/所处菜单的位置，使其相应菜单呈激活状态
            check:9999
        };
    },
      created() {
          // let data = []
          // for (let i = 0; i < source.length; i++) {
          //     let major = source[i]
          //     let childrenData= []
          //
          //     for (let j = 0; j < major.children.length; j++) {
          //         let child = major.children[j]
          //         // console.log(major.categoryCnName, child.categoryCnName)
          //         childrenData.push({"label": child.categoryCnName, id: child.id})
          //     }
          //
          //     let fieldData = {"label": major.categoryCnName, id: major.id, children: childrenData}
          //     data.push(fieldData)
          // }
          // this.data = data
          // console.log(JSON.stringify(data));


            if (this.$route.path.indexOf('research') != -1) {
            this.revealing=true
            //进入当前页面首先进行数据的分割
            this.loop(this.data);
            // 进入页面激活相应菜单的状态
            // 因不确定当前点击的为一级还是二级，又因this.$route.query中只有一个键值对，所以直接用以下方法获取值
            this.check = Object.values(this.$route.query)[0]


          }else{
            this.revealing=false
            this.check = this.$route.query.topic==''?'显示全部':this.$route.query.topic
          }

      },
    //   watch:{
    //     "$route": "determine"
    //   },
      methods: {
        articleToggle(item){
            // request({
            //     url: 'api/article/list?type=2&size=10&sort=createtime,desc&page=-1&topic='+item.label,
            //     method: 'get',
            // }).then(r => {
            //     console.log(r)
            //     window.open(r);
            // });
            // articleList/2
            this.check = item.label
            if (item.label == '显示全部') {
                // ?type=2&page=2&topic=&sort=date&order=1
                this.$router.push('/articleList/2?topic=&type=2&page=0&sort=date&order=1');
            } else {
                this.$router.push('/articleList/2?topic='+item.label+'&type=2&page=0&sort=date&order=1');
            }

        },
        // 切换菜单时进行触发
        // api/article/list?type=2&size=10&sort=createtime,desc&page=-1
          handleNodeClick(data) {
            // 用于标识当前是那个菜单
            this.check = data.id
            // 当前判定为是否为点击了显示全部
            if (data.id === undefined) {
                this.$router.push('/research');
                return;
            }else if(data.children === undefined){     //当前判定为是否为点击了二级菜单
                this.$router.push('/research?subCat=' + data.id);
            }else{              //当前判定为是否为点击了一级级菜单
                this.$router.push('/research?cat=' + data.id);
            }
          },
          // 分别截取前五个和除前五的数据
      loop(data){
        for (let i = 1; i < data.length; i++) {
          let arr={}
          //分割出前五个
          arr.head=data[i].children.slice(0,5)
          //分割出除前五个之外的
          arr.end=data[i].children.slice(5,data[i].children.length)
        //   分别添加到相对应的数组中
          this.headChildren.push(arr.head);
          this.endChildren.push(arr.end)
        }
      },
      // 二级菜单的收起与更多的切换
      toggle(index){
        let revealing=''
        // this.num ==1?this.num=0:this.num=1;
        if (this.data[index].revealing == "收起") {
          this.num='9999'
        // 点击的为收起使revealing变为false以供下方判定使用
          revealing=false
        } else {
          this.num=index
          revealing=true
        }
        // 点击更多/收起时先时所有的都变为更多
        for (let i = 0; i < this.data.length; i++) {
          this.data[i].revealing = "更多"
        }
        // 进行判定当前点击的更多还是收起，使其切换到相对面
        revealing  ? this.data[index].revealing = "收起" : this.data[index].revealing = "更多"
      },
      }
  }
  </script>

  <style>
  .el-tree.db-filter-tree .el-tree-node {
      white-space: initial;
  }

  .el-tree.db-filter-tree .el-tree-node__children .el-tree-node .el-tree-node__label {
      font-size: 12px;
  }

  .el-tree.db-filter-tree .el-tree-node__content {
      height: initial;
  }

  .research-filter > .el-tree-node > .el-tree-node__content {
      font-weight: bold;
  }
  </style>

  <style scoped>
  .tool { width: 268px; background: #fff; border: #e8e8e8 1px solid; overflow: hidden; }
  .tool h3 { line-height: 54px; border-bottom: #e8e8e8 1px solid; padding:0 20px ;font-size: 16px; font-weight: bold; color: #555;}
  .tool h3 a { float: right; font-size: 14px; font-weight: normal;}

  .mt15 { margin-top: 15px;}

  .tool_ul { padding: 12px 20px; overflow: hidden;}
  .mt15 .tool_ul { padding-right: 20px;}
  .tool_ul li { width: 124px; line-height: 40px; height: 40px; float: left;}
  .tool_ul li a { display: inline-block}
  .tool_ul li a img { float: left; margin: 10px 8px 0 0; width: 20px; height: 20px;}
.content{
    padding-left: 20px;
    margin: 15px 0 10px;
    color: #000;
    font-weight: bold;
}
.box{
  display: flex;
  align-items: baseline;
  margin-top: 5px;
  font-size: 16px;
  align-items: center;
  margin-left: -5px;
}
.box>div{
    margin: 0;
}
/* 二级菜单的样式 */
.subbox{
    margin-left: 20px;
    font-size: 14px;
    font-weight: initial;
}
/* 鼠标经过呈现的样式 */
.subbox:hover,
.box:hover{
  color: #14aab9 !important;
  font-weight: bold;
}
/* 激活状态的样式 */
.activate{
    color: #14aab9;
    font-weight: bold;
}
/* 二级菜单隐藏 */
.activate1{
  display: none;
}
/* 二级菜单显示 */
.activate2{
  display: block;
}
/* 下三角 */
.arrDown {
  width: 0;
  height: 0;
  margin-right: 5px;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
  border-top: 5px solid gray;
  cursor: pointer;
}
  </style>



// WEBPACK FOOTER //
// src/components/ResearchLeftBar.vue